import { Button } from '@mui/material';
import MyTooltip from '../utils/tooltip';
import { ChevronLeft, ChevronRight, SkipNext, SkipPrevious } from '@mui/icons-material';
import { useEffect } from 'react';
import { is } from 'date-fns/locale';

export default function PaginationButtons({
	handleSkipToStart = () => {},
	handlePrevClick = () => {},
	handleNextClick = () => {},
	handleSkipToEnd = () => {},
	current = 1,
	total = 50,
	limit = 25,
	isLoading = false,
}: {
	handleSkipToStart?: () => void;
	handlePrevClick?: () => void;
	handleNextClick?: () => void;
	handleSkipToEnd?: () => void;
	current?: number;
	total?: number;
	limit?: number;
	isLoading?: boolean;
}) {
	useEffect(() => {
		console.log('isloadingg', isLoading);
	}, [isLoading]);
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'center',
				outlineWidth: 0,
				outlineColor: 'black',
				outlineStyle: 'solid',
				width: '250px',
				padding: '5px',
				marginTop: 10,
				marginBottom: 10,
			}}
		>
			<MyTooltip title="Start">
				<span>
					<Button
						// variant=""
						// style={{ fontSize: '10px' }}
						onClick={handleSkipToStart}
						disabled={isLoading || current <= 0}
						style={{
							color: isLoading || current <= 0 ? '#ddd' : '#0859a4',
							width: 30,
							height: 30,
						}}
					>
						<SkipPrevious />
					</Button>
				</span>
			</MyTooltip>
			<MyTooltip title="Previous">
				<span>
					<Button
						color="secondary"
						// variant="contained"
						// style={{ fontSize: '10px' }}
						onClick={handlePrevClick}
						disabled={isLoading || current <= 0}
						style={{
							color: isLoading || current <= 0 ? '#ddd' : '#0859a4',
							width: 30,
							height: 30,
						}}
					>
						<ChevronLeft />
					</Button>
				</span>
			</MyTooltip>
			<MyTooltip title="Next">
				<span>
					<Button
						color="secondary"
						// variant="contained"
						// style={{ fontSize: '10px' }}
						style={{
							color: isLoading || total <= current + limit ? '#ddd' : '#0859a4',
							width: 30,
							height: 30,
						}}
						onClick={handleNextClick}
						disabled={isLoading || total <= current + limit}
					>
						<ChevronRight />
					</Button>
				</span>
			</MyTooltip>
			<MyTooltip title="End">
				<span>
					<Button
						color="secondary"
						// variant="contained"
						// style={{ fontSize: '10px' }}
						onClick={handleSkipToEnd}
						disabled={isLoading || total <= current + limit}
						style={{
							color: isLoading || total <= current + limit ? '#ddd' : '#0859a4',
							width: 30,
							height: 30,
						}}
					>
						<SkipNext />
					</Button>
				</span>
			</MyTooltip>
		</div>
	);
}
